// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ICreateSessionRequest {
    static getAttributeTypeMap() {
        return ICreateSessionRequest.attributeTypeMap;
    }
}
ICreateSessionRequest.discriminator = undefined;
ICreateSessionRequest.additionalProperties = false;
ICreateSessionRequest.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
];
//# sourceMappingURL=iCreateSessionRequest.js.map